import { render, staticRenderFns } from "./ModuleLists.vue?vue&type=template&id=6d0c1a20&"
import script from "./ModuleLists.vue?vue&type=script&lang=js&"
export * from "./ModuleLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports